import React from 'react'
import { Typography } from '@mui/material'

export default function PricePaginationRange({ from, to, count, page, pageSize }) {
    return (
        <>
            <span>{`${from}\u2013${to} of ${count}`}</span>
            <Typography component='span' sx={{ ml: 1 }}>
                {`Page ${count === 0 ? 0 : page + 1} of ${Math.ceil(count / pageSize)}`}
            </Typography>
        </>
    )
}
